import LayoutPrimary from '../../layouts/Primary';
import StepIndex from '../../views/Admin/Config/Step/StepIndex';
import StepEdit from '../../views/Admin/Config/Step/StepEdit';
import StepCreate from '../../views/Admin/Config/Step/StepCreate';

export default [
    {
        path: '/step/create',
        name: 'StepCreate',
        component: StepCreate,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
    {
        path: '/step/index',
        name: 'StepIndex',
        component: StepIndex,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
        props: true,
    },
    {
        path: '/step/edit/:id',
        name: 'StepEdit',
        component: StepEdit,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
];
